import DateService from 'live/services/date'
import Utils from 'live/lib/utils'
import { CustomPlotlineElement, ExtendedPlotline } from './index'
import { CustomPlotlineTooltip } from './tooltip'

export default function Timestamp(plotline: ExtendedPlotline): CustomPlotlineElement {
    if (plotline.options.id === 'placeholder') {
        return ({ update: () => null, destroy: () => null } as unknown) as CustomPlotlineElement
    }

    const { value, id } = plotline.options
    const chart = plotline.axis.chart
    const marker = plotline.linePath
    const isInverted = chart.inverted
    // Force timestamp to be in the oposite side of the tooltip
    const flip = (plotline.tooltip as CustomPlotlineTooltip).flip ? -5 : 15

    const x = isInverted ? marker.start.x : marker.start.x
    const y = isInverted ? marker.start.y + flip : marker.start.y - 2

    const timestamp: CustomPlotlineElement = chart.renderer
        .text(chart.spanType === 'time' ? DateService.formatTime(value) : Utils.formatNumber(value, 0, 4), x, y)
        .css({ color: '#868695', fontSize: '12px', fontFamily: 'SourceSansPro-Regular', fontWeight: 'bold' })
        .attr({
            id: id + '-timestamp',
            'text-anchor': isInverted ? undefined : 'middle',
            zIndex: 13
        })
        .add()

    timestamp.update = function ({ linePath: marker, focus, tooltip, axis: { chart }, options: { value } }, hide) {
        const flip = (tooltip as CustomPlotlineTooltip).flip ? -5 : 15
        const val = chart.spanType === 'time' ? DateService.formatTime(value) : Utils.formatNumber(value, 0, 4)

        this.attr({
            text: val,
            x: isInverted ? marker.start.x : marker.start.x,
            y: isInverted ? marker.start.y + flip : marker.start.y - 2,
            visibility: hide || !focus ? 'hidden' : 'visible'
        })

        return null
    }

    timestamp.destroy = function (this: CustomPlotlineElement) {
        this.update = () => null

        return Object.getPrototypeOf(this).destroy.call(this)
    }

    return timestamp
}
